import { render, staticRenderFns } from "./EntryDetails.vue?vue&type=template&id=360f3502&scoped=true&"
import script from "./EntryDetails.vue?vue&type=script&lang=js&"
export * from "./EntryDetails.vue?vue&type=script&lang=js&"
import style0 from "./EntryDetails.vue?vue&type=style&index=0&id=360f3502&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360f3502",
  null
  
)

export default component.exports